import { z } from "zod";

export const BrazilAddressSchema = z
  .object({
    cep: z
      .string()
      .regex(/^\d{5}-\d{3}$/)
      .optional(),
    street: z.string().max(200).optional(),
    number: z.string().max(20).optional(),
    complement: z.string().max(100).optional(),
    district: z.string().max(100).optional(),
    city: z.string().max(100).optional(),
    state: z.string().length(2).optional(),
  })
  .describe("Brazilian postal address.");

export type BrazilAddress = z.infer<typeof BrazilAddressSchema>;

export const formatBrazilAddress = (address: BrazilAddress | undefined): string | undefined => {
  if (!address) return undefined;
  const streetLine = [address.street, address.number, address.complement]
    .filter(Boolean)
    .join(", ");
  const cityLine = [address.city, address.state].filter(Boolean).join("/");
  const parts = [streetLine, address.district, cityLine, address.cep].filter(Boolean);

  return parts.length ? parts.join(" – ") : undefined;
};
